import { render, staticRenderFns } from "./chess.vue?vue&type=template&id=78128b1a&scoped=true&"
import script from "./chess.vue?vue&type=script&lang=js&"
export * from "./chess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78128b1a",
  null
  
)

export default component.exports